import React from 'react';
import TextLineEdit from '@plone/volto/components/manage/TextLineEdit/TextLineEdit';
import { Image } from 'semantic-ui-react';

const HighlightView = ({ data, isEditMode, filteredToolbarProps }) => {
  const iconElement = data.icon && (
    <Image
      src={`${data.icon['@id']}/@@images/image/large`}
      alt={'icon'}
      className="icon"
    />
  );
  const quoteSvg = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="7 9 25 25"
      className="quote-icon"
      style={{ fill: 'white' }}
    >
      <g fillRule="evenodd">
        <path d="M28 18L28 10 20 10 20 18 26 18C26 21.3137085 23.3137085 24 20 24L20 26C24.418278 26 28 22.418278 28 18L28 18zM26 12L26 16 22 16 22 12 26 12 26 12zM16 18L16 10 8 10 8 18 14 18C14 21.3137085 11.3137085 24 8 24L8 26C12.418278 26 16 22.418278 16 18L16 18zM14 12L14 16 10 16 10 12 14 12 14 12z" />
      </g>
    </svg>
  );

  const decoElement = (
    <div className="deco-svg">
      <svg
        width="3054"
        xmlns="http://www.w3.org/2000/svg"
        height="495"
        id="screenshot-8a829549-81ae-807b-8007-29ced22d5e1c"
        viewBox="300 50 3054 495"
        fill="none"
        version="1.1"
      >
        <g id="shape-8a829549-81ae-807b-8007-29ced22d5e1c" rx="0" ry="0">
          <g id="shape-0d20ed6f-64c8-801b-8007-1fa7232bb233">
            <g
              className="fills"
              id="fills-0d20ed6f-64c8-801b-8007-1fa7232bb233"
            >
              <path
                d="M476.4290771484375,6.09375L248.99346923828125,392.34375L1855.05517578125,2.03125L2477,6.09375L2477,492.96875L0,495L4.31158447265625,0L476.4290771484375,6.09375"
                style={{ fill: 'rgb(177, 178, 181)', fillOpacity: 1 }}
              />
            </g>
          </g>
          <g id="shape-0d20ed6f-64c8-801b-8007-1fa600a13b9a">
            <g
              className="fills"
              id="fills-0d20ed6f-64c8-801b-8007-1fa600a13b9a"
            >
              <path
                d="M297,450.125L2461.2666015625,248L3054,249.96875L3051.129638671875,492.53125L298.43524169921875,494L297,450.125"
                style={{ fill: 'rgb(0, 0, 0)', fillOpacity: 0.72 }}
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );

  const textElement = isEditMode ? (
    <div>
      <TextLineEdit
        {...filteredToolbarProps}
        renderTag="p"
        fieldDataName="text"
        properties={{ text: data.text || '' }}
        placeholder="Text eingeben"
      />
    </div>
  ) : (
    data?.text && <p>{data.text}</p>
  );

  const textColumn = (
    <>
      {iconElement}
      {textElement}
    </>
  );

  return (
    <div className="full-width zitat-wrapper">
      {decoElement}

      <div className={`${data.color} `}>
        <div className="zitat-container columns-view">
          {quoteSvg}
          <div className="zitat-text">{textColumn}</div>

          <div className="zitat-autor">
            <span className="autor-name">
              {data.autor}
              {data.autor_funktion && ', '}
            </span>
            <span className="autor-funktion">{data.autor_funktion}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HighlightView;
